import { Field, Form, Formik } from "formik";
import styles from "./Relatorios.module.css";
import { Box } from "@mui/material";
import Select from "react-select";
import Loading from "../../../components/components-ui/Loading/Loading";
import { Col, Grid } from "../../../components/Grid";
import Button from "../../../components/components-ui/Button/Button";
import Container from "../../../components/components-ui/Container/Container";
import { useContext, useEffect, useState } from "react";
import {
  customStyles,
  SelectSearch,
} from "../../../components/components-ui/SelectSearch/SelectSearch";
import api from "../../../services/Api";
import ExportCSV from "../../../services/ExportCSV";
import { exportToCSV } from "../../../utils/exportToCSV";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Provider/AuthContext";
import { useVerificaPermissao } from "../../../utils/verificaPermissao";

const customStylesBorder = {
  control: (base, state) => ({
    ...base,
    border: state.isDisabled ? "1px solid #black" : "2px solid #0b813c",
    backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
    boxShadow: state.isFocused ? "0 0 0 2px #0b813c" : "none",
    "&:hover": {
      borderColor: state.isDisabled ? "#ccc" : "#0b813c",
      boxShadow: "0 0 0 1px #0b813c",
    },
    borderColor: state.isFocused ? "#0b813c" : "", // Cor do border quando em foco ou não
    outline: "black", // Remover o outline padrão, se necessário
    fontSize: "12px", // Altera o tamanho da fonte
    height: 26,
    minHeight: 26,
    cursor: state.isDisabled ? "not-allowed" : "default",
  }),
  // Estilos placeholder
  placeholder: (styles) => ({
    ...styles,
    color: "black", // Cor do placeholder
  }),
  // Estilos opções
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#0b813c"
      : state.isFocused
      ? "rgba(11, 129, 60, 0.3)"
      : "white", // Cor de fundo das opções
    color: state.isSelected ? "white" : "#000", // Cor do texto das opções
    fontSize: "12px",
  }),
  container: (provided) => ({
    ...provided,
    height: 26,
    minHeight: 26,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "100%",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 3px",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const API_USUARIOS = "/usuario/view";
const API_GRUPOS = "/grupo/index";
const API_PONTOS_STATUS = "/pontos/status";
const API_PREPOSTO = "/preposto/index";
const API_PONTOS = "/pontos?razao_social=";
const API_VEICULOS = "/veiculo/index";
const API_LOCAIS = "/freguesia/listalocalfreguesia?nome_local=";

const API_GRUPOS_RELATORIO = "/relatorios/grupos";
const API_RELATORIOS_DO_GRUPO = "/relatorios/relatoriosporgrupo/";
const API_RELATORIO = "/relatorios/relatorio/";

const hoje = new Date();
const ano = hoje.getFullYear();
const mes = hoje.getMonth(); // 0 = janeiro

// Início do mês
const inicioDoMes = new Date(ano, mes, 1);

// Fim do mês
const fimDoMes = new Date(ano, mes + 1, 0);

// Função para formatar no formato 'yyyy-mm-dd'
function formatarData(data) {
  const yyyy = data.getFullYear();
  const mm = String(data.getMonth() + 1).padStart(2, "0");
  const dd = String(data.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export default function Relatorios() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [selectRelatorioGrupo, setSelectRelatorioGrupo] = useState([]);
  const [relatoriosDoGrupo, setRelatoriosDoGrupo] = useState([]);
  const [relatorio, setRelatorio] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [locais, setLocais] = useState([]);
  const [pontos, setPontos] = useState([]);
  const [pontosStatus, setPontosStatus] = useState([]);
  const [preposto, setPreposto] = useState([]);
  const [inputPonto, setInputPonto] = useState("a");
  const [inputLocal, setInputLocal] = useState("aa");
  const [loadingInput, setLoadingInput] = useState(false);
  const [endpoint, setEndpoint] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela de relatorios
    verificaPermissao(idTipoUsuario, 82);
    getRelatoriosDoGrupo(1);
  }, []);

  const getGrupos = async () => {
    await api
      .get(API_GRUPOS_RELATORIO)
      .then((res) => setSelectRelatorioGrupo(res.data.data))
      .catch((error) => console.log(error));
  };

  const getRelatoriosDoGrupo = async (idGrupo) => {
    setRelatorio([]); // Resetar os campos de filtro
    await api
      .get(API_RELATORIOS_DO_GRUPO + idGrupo)
      .then((res) => setRelatoriosDoGrupo(res.data.data))
      .catch((error) => console.log(error));
  };

  const getRelatorio = async (IdRelatorio) => {
    await api
      .get(API_RELATORIO + IdRelatorio)
      .then((res) => {
        setRelatorio(res.data.data);
        setEndpoint(res.data.data?.Endpoint);
      })
      .catch((error) => console.log(error));
  };

  const getUsuarios = async () => {
    await api
      .get(API_USUARIOS)
      .then((res) => setUsuarios(res.data))
      .catch((error) => console.log(error));
  };

  const getVeiculos = async () => {
    await api
      .get(API_VEICULOS)
      .then((res) => setVeiculos(res.data))
      .catch((error) => console.log(error));
  };

  const getGruposSelect = async () => {
    await api
      .get(API_GRUPOS)
      .then((res) => setGrupos(res.data))
      .catch((error) => console.log(error));
  };

  const getPontos = async (input) => {
    setLoadingInput(true);
    await api
      .get(API_PONTOS + input)
      .then((res) => setPontos(res.data.data))
      .catch((error) => console.log(error))
      .finally(() => setLoadingInput(false));
  };

  const getPontosStatus = async () => {
    await api
      .get(API_PONTOS_STATUS)
      .then((res) => setPontosStatus(res.data.data))
      .catch((error) => console.log(error));
  };

  const getPreposto = async () => {
    await api
      .get(API_PREPOSTO)
      .then((res) => setPreposto(res.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getGrupos();
    getUsuarios();
    getVeiculos();
    getGruposSelect();
    getPontosStatus();
    getPreposto();
  }, []);

  //Buscar pontos ao digitar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputPonto.length) {
        getPontos(inputPonto);
      } else {
        setPontos([]);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [inputPonto]);

  const getLocais = async (input) => {
    setLoadingInput(true);
    await api
      .get(API_LOCAIS + input)
      .then((res) => {
        setLocais(res.data.data);
        setLoadingInput(false);
      })
      .catch((error) => {
        setLoadingInput(false);
        console.log(error);
      });
  };

  //Buscar locais ao digitar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputLocal.length) {
        getLocais(inputLocal);
      } else {
        setLocais([]);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [inputLocal]);

  const handleChangeLocal = async (selectedOption, setFieldValue) => {
    setFieldValue("local", selectedOption); // Setar valor do select
  };

  const handleChangeGrupo = async (selectedOption, setFieldValue, values) => {
    setFieldValue("grupoRelatorio", selectedOption?.value);
    setIsLoading(true);
    await getRelatoriosDoGrupo(selectedOption.value);
    setIsLoading(false);
  };

  const hangleChangePonto = async (selectedOption, setFieldValue) => {
    setFieldValue("ponto", selectedOption);
  };

  //Funçoes relatorios
  const exportarDados = async (values) => {
    const data = {
      diaDe: values?.dataDe || null,
      diaAte: values?.dataAte || null,
      mesReferencia: values?.mesReferencia || null,
      anoReferencia: values?.anoReferencia || null,
      dataFixa: values?.dataFixa || null,
      idUsuario: values?.usuario || null,
      idVeiculo: values?.veiculo || null,
      idLocal: values?.local?.value || null,
      idGrupo: values?.grupo || null,
      freguesia: values?.freguesia || null,
      idStatusPonto: values?.statusPonto || null,
      idPreposto: values?.preposto || null,
      idPonto: values?.ponto?.value || null,
    };

    setLoadingData(true);
    await api
      .post(endpoint, data)
      .then((res) => {
        if (res.data.error === 0) {
          exportToCSV(res.data.data, relatorio?.Titulo || "Relatório");
          return;
        }
        toast.warn(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      })
      .finally(() => setLoadingData(false));
  };

  const resetFilters = (setValues, values) => {
    setValues({
      grupoRelatorio: values?.grupoRelatorio,
      dataDe: formatarData(inicioDoMes),
      dataAte: formatarData(fimDoMes),
      mesReferencia: "",
      anoReferencia: null,
      dataFixa: "",
      usuario: null,
      veiculo: null,
      local: null,
      grupo: null,
      freguesia: "",
      statusPonto: null,
      preposto: 1,
      ponto: null,
    });
  };

  return (
    <Container>
      <h3 className={styles.container_title}>
        Relatórios <span>{relatorio?.Titulo || ""}</span>
      </h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{
            grupoRelatorio: 1,
            dataDe: formatarData(inicioDoMes),
            dataAte: formatarData(fimDoMes),
            mesReferencia: "",
            anoReferencia: null,
            dataFixa: "",
            usuario: null,
            veiculo: null,
            local: null,
            grupo: null,
            freguesia: "",
            statusPonto: null,
            preposto: 1,
            ponto: null,
          }}
          enableReinitialize={true}
          //   validationSchema={validationSchema}
          onSubmit={(values) => exportarDados(values)}
        >
          {({
            errors,
            touched,
            values,
            setValues,
            isSubmitting,
            setFieldValue,
            resetForm,
          }) => (
            <Form style={{ width: "100%", height: "100%" }}>
              <div className={styles.container_box}>
                <Box border={1} padding={2} flex={1} minHeight={"100%"}>
                  <h4>Listagem</h4>
                  <Grid>
                    <Col size={12}>
                      <Field name="grupoRelatorio">
                        {({ field }) => {
                          const selectedOption = selectRelatorioGrupo.find(
                            (opt) =>
                              opt.IdRelatorioGrupo === values.grupoRelatorio
                          );

                          return (
                            <Select
                              {...field}
                              onChange={(selectedOption) =>
                                handleChangeGrupo(
                                  selectedOption,
                                  setFieldValue,
                                  values
                                )
                              }
                              value={
                                selectedOption
                                  ? {
                                      label: selectedOption.RelatorioGrupo,
                                      value: selectedOption.IdRelatorioGrupo,
                                    }
                                  : null
                              }
                              options={selectRelatorioGrupo.map((item) => ({
                                label: item.RelatorioGrupo,
                                value: item.IdRelatorioGrupo,
                              }))}
                              styles={customStyles}
                              placeholder="Selecione..."
                            />
                          );
                        }}
                      </Field>
                      {errors.grupoRelatorio && touched.grupoRelatorio ? (
                        <span className={styles.alertError}>
                          {errors.grupoRelatorio}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid height={"85%"}>
                    <Box border={1} marginTop={1} padding={1} width={"100%"}>
                      {relatoriosDoGrupo.length ? (
                        <ul style={{ height: "100%" }}>
                          {isLoading ? (
                            <div className={styles.loading_container}>
                              <Loading />
                            </div>
                          ) : (
                            <select
                              multiple
                              className={styles.list_acoes_select}
                            >
                              {relatoriosDoGrupo.map((item) => (
                                <option
                                  key={item.IdRelatorio}
                                  value={item.IdRelatorio}
                                  onClick={() => {
                                    resetFilters(setValues, values);
                                    getRelatorio(item.IdRelatorio);
                                  }}
                                >
                                  {item.Titulo}
                                </option>
                              ))}
                            </select>
                          )}
                        </ul>
                      ) : null}
                    </Box>
                  </Grid>
                </Box>
                <Box border={1} padding={2} flex={1} height={"100%"}>
                  <h4>Filtros</h4>
                  <Grid>
                    <Col size={6}>
                      <label>Data De</label>
                      <Field
                        type="date"
                        name="dataDe"
                        className={styles.campo}
                        // disabled={relatorio?.fHorarioColetaDe !== 1}
                      />
                      {errors.dataDe && touched.dataDe ? (
                        <span className={styles.alertError}>
                          {errors.dataDe}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={6}>
                      <label>Data Até</label>
                      <Field
                        type="date"
                        name="dataAte"
                        className={styles.campo}
                        // disabled={relatorio?.fHorarioColetaAte !== 1}
                      />
                      {errors.dataAte && touched.dataAte ? (
                        <span className={styles.alertError}>
                          {errors.dataAte}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={6}>
                      <label>Mes De Referencia</label>
                      <Field
                        type="month"
                        name="mesReferencia"
                        className={styles.campo}
                        disabled={relatorio?.fMes !== 1}
                      />
                      {errors.mesReferencia && touched.mesReferencia ? (
                        <span className={styles.alertError}>
                          {errors.mesReferencia}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={6}>
                      <label>Ano De Referência</label>
                      <Field
                        type="text"
                        min={1900}
                        max={2100}
                        pattern="\d{4}"
                        maxLength={4}
                        name="anoReferencia"
                        className={styles.campo}
                        disabled={relatorio?.fAno !== 1}
                      />
                      {errors.anoReferencia && touched.anoReferencia ? (
                        <span className={styles.alertError}>
                          {errors.anoReferencia}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={6}>
                      <label>Data Fixa</label>
                      <Field
                        type="date"
                        name="dataFixa"
                        className={styles.campo}
                        disabled={relatorio?.fDataFixa !== 1}
                      />
                      {errors.dataFixa && touched.dataFixa ? (
                        <span className={styles.alertError}>
                          {errors.dataFixa}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={6}>
                      <label>Usuário</label>
                      <Field
                        name="usuario"
                        component={SelectSearch}
                        options={usuarios.map((values) => ({
                          label: values?.nome_usuario,
                          value: values?.id_usuario,
                        }))}
                        style={customStylesBorder}
                        disabled={relatorio?.fUsuario !== 1}
                      />
                      {errors.usuario && touched.usuario ? (
                        <span className={styles.alertError}>
                          {errors.usuario}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={12}>
                      <label>Veículo</label>
                      <Field
                        name="veiculo"
                        component={SelectSearch}
                        options={veiculos.map((values) => ({
                          label: values?.placa,
                          value: values?.IDVeiculo,
                        }))}
                        style={customStylesBorder}
                        disabled={relatorio?.fIDVeiculo !== 1}
                      />
                      {errors.veiculo && touched.veiculo ? (
                        <span className={styles.alertError}>
                          {errors.veiculo}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={12}>
                      <label>Local</label>
                      <Field name="local">
                        {({ ...field }) => (
                          <Select
                            {...field}
                            value={values.local}
                            options={locais.map((values) => ({
                              label: values?.NomeLocal,
                              value: values?.IdLocal,
                            }))}
                            styles={customStylesBorder}
                            placeholder="Digite para buscar..."
                            noOptionsMessage={() =>
                              loadingInput
                                ? "Carregando..."
                                : inputLocal.length
                                ? "Nenhuma opção encontrada"
                                : "Digite parte do nome"
                            }
                            onChange={(selectedOption) =>
                              handleChangeLocal(selectedOption, setFieldValue)
                            }
                            onInputChange={(e) => setInputLocal(e)}
                            isClearable
                            isDisabled={relatorio?.fIdLocal !== 1}
                          />
                        )}
                      </Field>
                      {errors.local && touched.local ? (
                        <span className={styles.alertError}>
                          {errors.local}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={12}>
                      <label>Grupo</label>
                      <Field
                        name="grupo"
                        component={SelectSearch}
                        options={grupos.map((values) => ({
                          label: values?.descricao_grupo,
                          value: values?.id_grupo,
                        }))}
                        menuPlacement={"top"}
                        style={customStylesBorder}
                        disabled={relatorio?.fIdGrupo !== 1}
                      />
                      {errors.grupo && touched.grupo ? (
                        <span className={styles.alertError}>
                          {errors.grupo}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={6}>
                      <label>Freguesia</label>
                      <Field
                        type="text"
                        name="freguesia"
                        className={styles.campo}
                        disabled={relatorio?.fFreguesia !== 1}
                      />
                      {errors.freguesia && touched.freguesia ? (
                        <span className={styles.alertError}>
                          {errors.freguesia}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={6}>
                      <label>Status Ponto</label>
                      <Field
                        name="statusPonto"
                        component={SelectSearch}
                        options={pontosStatus.map((item) => ({
                          label: item.Status,
                          value: item.IDStatus,
                        }))}
                        menuPlacement={"top"}
                        style={customStylesBorder}
                        disabled={relatorio?.fIDPontoStatus !== 1}
                      />
                      {errors.statusPonto && touched.statusPonto ? (
                        <span className={styles.alertError}>
                          {errors.statusPonto}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  <Grid>
                    <Col size={6}>
                      <label>Preposto</label>
                      <Field
                        name="preposto"
                        component={SelectSearch}
                        options={preposto.map((values) => ({
                          label: values?.RazaoSocial,
                          value: values?.IdPreposto,
                        }))}
                        style={customStylesBorder}
                        disabled={relatorio?.fIdPreposto !== 1}
                      />
                      {errors.preposto && touched.preposto ? (
                        <span className={styles.alertError}>
                          {errors.preposto}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={6}>
                      <label>Ponto</label>
                      <Field name="ponto">
                        {({ ...field }) => (
                          <Select
                            {...field}
                            value={values.ponto}
                            options={pontos.map((item) => ({
                              label: item.RazaoSocial,
                              value: item.IDPonto,
                            }))}
                            styles={customStylesBorder}
                            placeholder="Digite para buscar..."
                            noOptionsMessage={() =>
                              loadingInput
                                ? "Carregando..."
                                : inputPonto.length
                                ? "Nenhuma opção encontrada"
                                : "Digite parte do nome"
                            }
                            onChange={(selectedOption) =>
                              hangleChangePonto(selectedOption, setFieldValue)
                            }
                            onInputChange={(e) => setInputPonto(e)}
                            menuPlacement="top"
                            isClearable
                            isDisabled={relatorio?.fIDPonto !== 1}
                          />
                        )}
                      </Field>
                      {errors.ponto && touched.ponto ? (
                        <span className={styles.alertError}>
                          {errors.ponto}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                </Box>
              </div>
              <div className={styles.button_container}>
                <Button
                  type="button"
                  className={styles.button}
                  disabled={loadingData}
                >
                  <i
                    class="fas fa-print"
                    style={{ color: "white", marginRight: "12px" }}
                  ></i>
                  Visualizar Impressão
                </Button>
                <Button
                  type="submit"
                  className={styles.button}
                  disabled={loadingData}
                >
                  <i
                    class="fas fa-save"
                    style={{ color: "white", marginRight: "12px" }}
                  ></i>
                  Exportar Dados
                </Button>
                {/* <ExportCSV
                  nameButton="Exportar Dados"
                  fileName={relatorio?.Titulo || "Relatório"}
                  csvData={dados}
                /> */}
              </div>
              <div className={styles.loading_container}>
                <Loading display={loadingData ? "block" : "none"} />
              </div>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  );
}
